import { useQuery } from "@tanstack/react-query";
import { getDashboardLMFProduction } from "../../../repositories/ProductionRepository";
import type { LMFProcessByShift } from "../../../models/ProcessByShift";

export const useLMFProductionQuery = (
  startDate: Date | null,
  endDate: Date | null,
) => {
  return useQuery({
    queryKey: [
      "dashboard-lmf-production",
      startDate?.toISOString(),
      endDate?.toISOString(),
    ],
    meta: { realtime: ["RBD.GetDashboardLMFProduction"] },
    queryFn: async ({ signal }) => {
      const resp = await getDashboardLMFProduction(startDate, endDate, signal);
      if (resp.ok) {
        return (resp.data?.tables[0].rows as LMFProcessByShift[]) ?? [];
      }
      throw new Error(resp.message ?? "Failed to fetch LMF production");
    },
    enabled: !!startDate && !!endDate,
  });
};
